import { useAppServices } from 'hook/services'
import { useEffect, useState } from 'react'

export default function DataTableData() {
  const AppService = useAppServices()
  const [List, setList] = useState([])
  const [loader, setLoader] = useState(true)
  const id = window.location.pathname.split('/')[4]
  const getGhlLocations = async () => {
    setLoader(true)

    const query = new URLSearchParams({
      licenseKey: id.toString(),
    })

    const { response, error } = await AppService.agency.GetSuperAdminContacts({
      query: query.toString(),
    })

    if (response && response.success) {
      setList(response.data)
    } else {
      setList([])
      console.error('Error fetching data:', error)
    }

    setLoader(false)
  }

  const onLoad = () => {
    getGhlLocations()
  }
  useEffect(onLoad, [])

  return {
    loader,
    dataTableData: {
      columns: [
        { Header: 'First Name', accessor: 'firstName' },
        { Header: 'Last Name', accessor: 'lastName' },
        { Header: 'Contact Id', accessor: 'id' },
        { Header: 'Email', accessor: 'email' },
        { Header: 'License Key', accessor: 'customFields' },
        { Header: 'Tags', accessor: 'tags' },
      ],

      rows: List.map((data) => ({
        firstName: data?.contact?.firstName,
        lastName: data?.contact?.lastName,
        id: data?.contact?.id,
        email: data?.contact?.email,
        license_key:
          data?.contact?.customFields?.find((field) => field.id === 'dFQqRvfZqKhOGpIT7fWX')
            ?.value || 'N/A',
        tags:
          data?.contact?.tags?.length > 0 ? (
            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '5px' }}>
              {data.contact.tags.map((tag, index) => (
                <span
                  key={index}
                  style={{
                    backgroundColor: '#e0f7fa',
                    color: '#006064',
                    padding: '2px 8px',
                    borderRadius: '12px',
                    fontSize: '12px',
                    fontWeight: 500,
                  }}
                >
                  {tag}
                </span>
              ))}
            </div>
          ) : (
            'N/A'
          ),
      })),
    },
  }
}
